import React, { useContext, useState } from 'react';
import { useDisclosure, Grid, GridItem } from '@chakra-ui/react';
import BannerForm from './BannerForm';
import Banner from './Banner';
import context from '../context';

const Banners: React.FC = () => {
  const { pageGroup } = useContext(context);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [clickedBanner, setClickedBanner] = useState<any | undefined>(
    undefined,
  );

  const colsArray = [];
  let i = 0;
  // eslint-disable-next-line no-plusplus
  while (i++ < pageGroup?.cols ?? 1) colsArray.push(i);

  return (
    <>
      <Grid
        templateRows="repeat(1, 150px)"
        templateColumns={`repeat(${pageGroup?.cols}, 1fr)`}
        gap={3}
        justifyContent="center"
        mt={2}
      >
        {pageGroup?.cols > 1 && (
          <>
            {colsArray.map((_, index) => (
              <GridItem colSpan={1}>
                <Banner
                  banner={pageGroup?.items[index]}
                  index={0}
                  disabled={false}
                  onClick={banner => {
                    onOpen();
                    setClickedBanner(banner);
                  }}
                />
              </GridItem>
            ))}
          </>
        )}
      </Grid>

      <BannerForm
        isOpen={isOpen}
        banner={clickedBanner}
        onCreated={onClose}
        onClose={() => {
          setClickedBanner(undefined);
          onClose();
        }}
        onDeleted={() => {
          setClickedBanner(undefined);
          onClose();
        }}
        onUpdated={() => {
          setClickedBanner(undefined);
          onClose();
        }}
      />
    </>
  );
};

export default Banners;
